// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// const CLOUD_NAME = "dmtwtt5mz"; // ✅ Your Cloudinary cloud name
// const UPLOAD_PRESET = "provider_gallery_upload"; // ✅ Your Cloudinary upload preset
// const CLOUDINARY_API = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

// function UploadProviderProfileGallery() {
//   const { providerId } = useParams();
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [previewImages, setPreviewImages] = useState([]);
//   const [galleryImages, setGalleryImages] = useState([]);

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     const imageFiles = files.filter((file) => file.type.startsWith("image/"));
//     setSelectedImages(imageFiles);
//     setPreviewImages(imageFiles.map((file) => URL.createObjectURL(file)));
//   };

//   const handleUpload = async () => {
//     if (selectedImages.length === 0) {
//       alert("Please select at least one image file.");
//       return;
//     }

//     const uploaded = [];

//     for (const file of selectedImages) {
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("upload_preset", UPLOAD_PRESET);
//       formData.append("folder", "provider-gallery");

//       try {
//         const res = await fetch(CLOUDINARY_API, {
//           method: "POST",
//           body: formData,
//         });
//         const data = await res.json();

//         if (data.secure_url) {
//           uploaded.push({ url: data.secure_url });
//         }
//       } catch (err) {
//         console.error("Upload error:", err);
//       }
//     }

//     if (uploaded.length > 0) {
//       try {
//         const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;
//         const res = await axios.post(
//           `http://localhost:4000/gallery/upload/${providerId}`,
//           { images: uploaded },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         setGalleryImages(res.data.data);
//         setSelectedImages([]);
//         setPreviewImages([]);
//         alert("Images uploaded and saved to DB successfully!");
//       } catch (err) {
//         console.error("DB Save Error:", err);
//         alert("Uploaded to Cloudinary but failed to save in DB.");
//       }
//     } else {
//       alert("Image upload failed. Check your Cloudinary config.");
//     }
//   };

//   const handleDeleteImage = async (imageUrl) => {
//     const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;
//     try {
//       const res = await axios.delete(`http://localhost:4000/gallery/${providerId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         data: { imageUrl },
//       });
//       setGalleryImages(res.data.data);
//     } catch (err) {
//       console.error("Failed to delete image:", err);
//       alert("Delete failed");
//     }
//   };

//   const fetchGallery = async () => {
//     try {
//       const res = await axios.get(`http://localhost:4000/gallery/${providerId}`);
//       setGalleryImages(res.data.data);
//     } catch (err) {
//       console.error("Failed to load gallery", err);
//     }
//   };

//   useEffect(() => {
//     fetchGallery();
//   }, []);

//   return (
//     <div className="p-6 max-w-2xl mx-auto">
//       <h2 className="text-2xl font-semibold mb-4">Upload Gallery Images</h2>

//       <input type="file" multiple accept="image/*" onChange={handleFileChange} />

//       {previewImages.length > 0 && (
//         <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
//           {previewImages.map((src, index) => (
//             <img key={index} src={src} alt="preview" className="h-32 w-full object-cover rounded" />
//           ))}
//         </div>
//       )}

//       {selectedImages.length > 0 && (
//         <button
//           onClick={handleUpload}
//           className="bg-blue-500 text-white px-4 py-2 mt-4 rounded hover:bg-blue-600"
//         >
//           Upload Selected Images
//         </button>
//       )}

//       <hr className="my-6" />

//       <h3 className="text-xl font-semibold mb-3">Your Uploaded Images</h3>
//       {galleryImages.length === 0 ? (
//         <p>No images uploaded yet.</p>
//       ) : (
//         <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//           {galleryImages.map((img, index) => (
//             <div key={index} className="relative group">
//               <img
//                 src={img.url}
//                 alt={`Uploaded ${index}`}
//                 className="rounded object-cover h-40 w-full"
//               />
//               <button
//                 onClick={() => handleDeleteImage(img.url)}
//                 className="absolute top-2 right-2 text-xs bg-red-500 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
//               >
//                 Delete
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// export default UploadProviderProfileGallery;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const CLOUD_NAME = "dmtwtt5mz";
const UPLOAD_PRESET = "provider_gallery_upload";
const CLOUDINARY_API = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

const antIcon = (
  <LoadingOutlined style={{ fontSize: 60, color: "#2563eb" }} spin />
);

function UploadProviderProfileGallery() {
  const { providerId } = useParams();
  const [selectedImages, setSelectedImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));
    setSelectedImages(imageFiles);
    setPreviewImages(imageFiles.map((file) => URL.createObjectURL(file)));
  };

  const handleUpload = async () => {
    if (selectedImages.length === 0) {
      alert("Please select at least one image file.");
      return;
    }

    setLoading(true);
    const uploaded = [];

    for (const file of selectedImages) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", UPLOAD_PRESET);
      formData.append("folder", "provider-gallery");

      try {
        const res = await fetch(CLOUDINARY_API, {
          method: "POST",
          body: formData,
        });
        const data = await res.json();

        if (data.secure_url) {
          uploaded.push({ url: data.secure_url });
        }
      } catch (err) {
        console.error("Upload error:", err);
      }
    }

    if (uploaded.length > 0) {
      try {
        const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;
        const res = await axios.post(
          `${API_BASE}/gallery/upload/${providerId}`,
          { images: uploaded },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setGalleryImages(res.data.data);
        setSelectedImages([]);
        setPreviewImages([]);
        alert("Images uploaded and saved to DB successfully!");
      } catch (err) {
        console.error("DB Save Error:", err);
        alert("Uploaded to Cloudinary but failed to save in DB.");
      }
    } else {
      alert("Image upload failed. Check your Cloudinary config.");
    }

    setLoading(false);
  };

  const handleDeleteImage = async (imageUrl) => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;
    try {
      const res = await axios.delete(
        `${API_BASE}/gallery/${providerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: { imageUrl },
        }
      );
      setGalleryImages(res.data.data);
    } catch (err) {
      console.error("Failed to delete image:", err);
      alert("Delete failed");
    }
    setLoading(false);
  };

  const fetchGallery = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE}/gallery/${providerId}`
      );
      setGalleryImages(res.data.data);
    } catch (err) {
      console.error("Failed to load gallery", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGallery();
  }, []);
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      {/* Fullscreen Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center z-50">
          <Spin indicator={antIcon} />
          <p className="text-white mt-4 text-lg font-medium animate-pulse">
            Please wait...
          </p>
        </div>
      )}

      <h2 className="text-2xl font-semibold mb-4">Upload Gallery Images</h2>

      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileChange}
        className="mb-3"
      />

      {previewImages.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
          {previewImages.map((src, index) => (
            <img
              key={index}
              src={src}
              alt="preview"
              className="h-32 w-full object-cover rounded"
            />
          ))}
        </div>
      )}

      {selectedImages.length > 0 && (
        <button
          onClick={handleUpload}
          className="bg-blue-500 text-white px-4 py-2 mt-4 rounded hover:bg-blue-600"
        >
          Upload Selected Images
        </button>
      )}

      <hr className="my-6" />

      <h3 className="text-xl font-semibold mb-3">Your Uploaded Images</h3>
      {galleryImages.length === 0 ? (
        <p>No images uploaded yet.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((img, index) => (
            <div key={index} className="relative group">
              <img
                src={img.url}
                alt={`Uploaded ${index}`}
                className="rounded object-cover h-40 w-full"
              />
              <button
                onClick={() => handleDeleteImage(img.url)}
                className="absolute top-2 right-2 text-xs bg-red-500 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UploadProviderProfileGallery;
